import { useEffect, useState } from 'react';
import { getStrapiBackend } from '../Contentful_API/strapiBackend';

const REFRESH_MS = 5 * 60 * 1000;

/** Total matching entries, read from Strapi's pagination meta (one record fetched). Null when unknown. */
async function countEntries(apiBase, path) {
    const separator = path.includes('?') ? '&' : '?';
    const response = await fetch(`${apiBase}${path}${separator}fields[0]=id&pagination[pageSize]=1`, { credentials: 'omit' });
    if (!response.ok) return null;
    const result = await response.json();
    const total = result?.meta?.pagination?.total;
    return Number.isInteger(total) ? total : null;
}

/**
 * Live counts for the navigation badges: tenders whose closing date is still ahead, and public
 * consultations that are open (the CMS only returns enabled, published consultations).
 * A count stays null if it cannot be loaded, so no badge is shown rather than a wrong number.
 */
export async function loadOpenCounts(apiBase, now = new Date()) {
    const [tenders, consultations] = await Promise.all([
        countEntries(apiBase, `/tenders?filters[deadline][$gt]=${encodeURIComponent(now.toISOString())}`).catch(() => null),
        countEntries(apiBase, '/posts').catch(() => null),
    ]);
    return { tenders, consultations };
}

export function useOpenCounts() {
    const [counts, setCounts] = useState({ tenders: null, consultations: null });

    useEffect(() => {
        let active = true;
        const refresh = () => {
            loadOpenCounts(getStrapiBackend().apiUrl).then((next) => {
                if (active) setCounts(next);
            });
        };
        refresh();
        // Tenders close during the day; keep the badge honest on pages left open.
        const timer = setInterval(refresh, REFRESH_MS);
        return () => {
            active = false;
            clearInterval(timer);
        };
    }, []);

    return counts;
}

/** The navigation item that holds procurement, whichever way the CMS names it. */
export function isProcurementItem(item) {
    return /procure|aprovisionamento|aprovizionamentu|tender/i.test(`${item?.label || ''} ${item?.to || ''}`);
}
